import { usePageTracking } from '@/hooks/usePageTracking';

/**
 * Component that automatically tracks page views on route changes.
 * Must be placed inside Router but outside Routes.
 */
export function PageTracker() {
  usePageTracking();
  return null;
}
